import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { IPaymentAccount } from 'epay-library/lib/features/common/models/payment/paymentaccount';
import { IEmpEFTEmployee } from 'epay-library/lib/features/employer/models/eftFile/employerEFTEmp';
import { IEMPCCPayment } from 'epay-library/lib/features/employer/models/payment/creditcard/employerCCPayment';
import { IEMPPaymentCollection } from 'epay-library/lib/features/employer/models/payment/employerPaymentCollection';

const PayorValidationTypes = {
  scheduldedPayment: 'scheduledPayment',
  creditCard: 'creditCard',
  eftEdiFile: 'eftEdiFile',
};

@Component({
  selector: 'payor-validation-common',
  templateUrl: './payor-validation-common.component.html'
})
export class PayorValidationCommonComponent implements OnInit {
  @Input() baseurl = '';
  @Input() clientName = '';
  @Input() validationType = '';
  @Input() routingHelpImage = '';
  @Input() validationEftStep = 0;
  @Input() isEditPayment: boolean = false;
  @Input() eftFilePayorCollection: IEMPPaymentCollection[] = [];
  @Input() editPayorCollection: IEMPPaymentCollection[] = [];
  @Input() IPaymentAccount: IPaymentAccount = {} as IPaymentAccount;

  @Output() validPayorCollectionEmitter = new EventEmitter<{
    payorCollection: IEMPPaymentCollection[];
  }>();

  @Output() validCreditCardPaymentEmitter = new EventEmitter<IEMPCCPayment>();

  @Output() validEFTFileCollectionEmitterStep1 = new EventEmitter<
    IEMPPaymentCollection[]
  >();
  @Output() validEFTFileCollectionEmitterStep2 = new EventEmitter<
    IEmpEFTEmployee[]
  >();
  @Output() stepperBackEmitter = new EventEmitter<any>();

  payorCollection: IEMPPaymentCollection[] = [];
  ccPayment: IEMPCCPayment = {} as IEMPCCPayment;
  eftFilePayors: IEmpEFTEmployee[] = [];

  isCreditCardValidation: boolean = false;
  isEftFileValidation: boolean = false;
  isScheduledPaymentValidation: boolean = false;

  okSecondaryIdAlias = 'Family Group Number';

  constructor() {}

  ngOnInit(): void {
    if (this.validationType === PayorValidationTypes.creditCard) {
      this.isCreditCardValidation = true;
      this.isEftFileValidation = false;
      this.isScheduledPaymentValidation = false;
    }
    if (this.validationType === PayorValidationTypes.scheduldedPayment) {
      this.isCreditCardValidation = false;
      this.isEftFileValidation = false;
      this.isScheduledPaymentValidation = true;
    }
    if (this.validationType === PayorValidationTypes.eftEdiFile) {
      this.isCreditCardValidation = false;
      this.isEftFileValidation = true;
      this.isScheduledPaymentValidation = false;
    }
  }

  /////////////////////////////////////////////////////
  // Tennessee
  /////////////////////////////////////////////////////
  validPayorEmitted_TN(payors: any) {
    this.payorCollection = payors.payorCollection;

    this.validPayorCollectionEmitter.emit({
      payorCollection: this.payorCollection,
    });
  }

  validPayorCreditCardEmitted_TN(creditCardPayment: any) {
    this.ccPayment = creditCardPayment;
    this.validCreditCardPaymentEmitter.emit(this.ccPayment);
  }

  validPayorEFTFileEmittedStep1_TN(payorCollection: any) {
    this.payorCollection = payorCollection.payorCollection;
    this.validEFTFileCollectionEmitterStep1.emit(this.payorCollection);
  }

  validPayorEFTFileEmittedStep2_TN(eftFilePayors: any) {
    this.eftFilePayors = eftFilePayors.eftFilePayors;
    this.validEFTFileCollectionEmitterStep2.emit(this.eftFilePayors);
  }

  /////////////////////////////////////////////////////
  // West Virginia
  /////////////////////////////////////////////////////

  validPayorEmitted_WV(payors: any) {
    this.payorCollection = payors.payorCollection;

    this.validPayorCollectionEmitter.emit({
      payorCollection: this.payorCollection,
    });
  }

  validPayorEFTFileEmittedStep1_WV(payorCollection: any) {
    this.payorCollection = payorCollection.payorCollection;
    this.validEFTFileCollectionEmitterStep1.emit(this.payorCollection);
  }

  validPayorEFTFileEmittedStep2_WV(eftFilePayors: any) {
    this.eftFilePayors = eftFilePayors.eftFilePayors;
    this.validEFTFileCollectionEmitterStep2.emit(this.eftFilePayors);
  }

  /////////////////////////////////////////////////////
  // Oklahoma
  /////////////////////////////////////////////////////
  validPayorEmitted_OK(payors: any) {
    this.payorCollection = payors.payorCollection;

    this.validPayorCollectionEmitter.emit({
      payorCollection: this.payorCollection,
    });
  }

  validPayorCreditCardEmitted_OK(creditCardPayment: any) {
    this.ccPayment = creditCardPayment;
    this.validCreditCardPaymentEmitter.emit(this.ccPayment);
  }

  validPayorEFTFileEmittedStep1_OK(payorCollection: any) {
    this.payorCollection = payorCollection.payorCollection;
    this.validEFTFileCollectionEmitterStep1.emit(this.payorCollection);
  }

  validPayorEFTFileEmittedStep2_OK(eftFilePayors: any) {
    this.eftFilePayors = eftFilePayors.eftFilePayors;
    this.validEFTFileCollectionEmitterStep2.emit(this.eftFilePayors);
  }

  /////////////////////////////////////////////////////
  // Missouri
  /////////////////////////////////////////////////////
  validPayorEmitted_MO(payors: any) {
    this.payorCollection = payors.payorCollection;

    this.validPayorCollectionEmitter.emit({
      payorCollection: this.payorCollection,
    });
  }

  validPayorCreditCardEmitted_MO(creditCardPayment: any) {
    this.ccPayment = creditCardPayment;
    this.validCreditCardPaymentEmitter.emit(this.ccPayment);
  }

  validPayorEFTFileEmittedStep1_MO(payorCollection: any) {
    this.payorCollection = payorCollection.payorCollection;
    this.validEFTFileCollectionEmitterStep1.emit(this.payorCollection);
  }

  validPayorEFTFileEmittedStep2_MO(eftFilePayors: any) {
    this.eftFilePayors = eftFilePayors.eftFilePayors;
    this.validEFTFileCollectionEmitterStep2.emit(this.eftFilePayors);
  }

  /////////////////////////////////////////////////////
  // Colorado
  /////////////////////////////////////////////////////
  validPayorEmitted_CO(payors: any) {
    this.payorCollection = payors.payorCollection;

    this.validPayorCollectionEmitter.emit({
      payorCollection: this.payorCollection,
    });
  }

  validPayorCreditCardEmitted_CO(creditCardPayment: any) {
    this.ccPayment = creditCardPayment;
    this.validCreditCardPaymentEmitter.emit(this.ccPayment);
  }

  validPayorEFTFileEmittedStep1_CO(payorCollection: any) {
    this.payorCollection = payorCollection.payorCollection;
    this.validEFTFileCollectionEmitterStep1.emit(this.payorCollection);
  }

  validPayorEFTFileEmittedStep2_CO(eftFilePayors: any) {
    this.eftFilePayors = eftFilePayors.eftFilePayors;
    this.validEFTFileCollectionEmitterStep2.emit(this.eftFilePayors);
  }

  stepperBackEmitted() {
    this.stepperBackEmitter.emit();
  }
}
